import { render, staticRenderFns } from "./ProfileCreate.vue?vue&type=template&id=20ad59ff&scoped=true&"
import script from "./ProfileCreate.vue?vue&type=script&lang=js&"
export * from "./ProfileCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCreate.vue?vue&type=style&index=0&id=20ad59ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad59ff",
  null
  
)

export default component.exports